import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Archive } from "lucide-react";
import { toast } from "sonner";
import ImportDialog from "@/components/ImportDialog";

export default function Exercises() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("atletico");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", macro_category: "atletico", category: "", description: "", duration: "", sets: "", reps: "" });

  const load = () => api.get("/exercises").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/exercises", form); toast.success("Esercizio creato"); setOpen(false); load(); }
    catch { toast.error("Errore"); }
  };

  const archive = async (ex) => {
    await api.put(`/exercises/${ex.id}`, { ...ex, archived: true });
    toast.success("Archiviato"); load();
  };

  const filtered = items.filter((x) => x.macro_category === tab && !x.archived);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="font-heading text-4xl font-bold tracking-tight">Libreria Esercizi</h1>
          <p className="text-zinc-500 mt-1">Atletici e specifici di scherma.</p>
        </div>
        <div className="flex items-center gap-2">
          <ImportDialog entity="exercises" onDone={load} />
          <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="new-ex-btn" className="h-12 bg-black hover:bg-zinc-800"><Plus className="w-4 h-4 mr-2" />Nuovo esercizio</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuovo esercizio</DialogTitle></DialogHeader>
            <div className="space-y-3 py-2">
              <div><Label>Titolo</Label><Input data-testid="ex-title" value={form.title} onChange={(e) => setForm({...form, title: e.target.value})} /></div>
              <div>
                <Label>Macro categoria</Label>
                <Select value={form.macro_category} onValueChange={(v) => setForm({...form, macro_category: v})}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent><SelectItem value="atletico">Atletico</SelectItem><SelectItem value="scherma">Scherma</SelectItem></SelectContent>
                </Select>
              </div>
              <div><Label>Categoria</Label><Input value={form.category} onChange={(e) => setForm({...form, category: e.target.value})} /></div>
              <div><Label>Descrizione</Label><Textarea rows={3} value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} /></div>
              <div className="grid grid-cols-3 gap-3">
                <div><Label>Durata</Label><Input value={form.duration} onChange={(e) => setForm({...form, duration: e.target.value})} /></div>
                <div><Label>Serie</Label><Input value={form.sets} onChange={(e) => setForm({...form, sets: e.target.value})} /></div>
                <div><Label>Ripetizioni</Label><Input value={form.reps} onChange={(e) => setForm({...form, reps: e.target.value})} /></div>
              </div>
            </div>
            <DialogFooter><Button data-testid="ex-save" onClick={save} className="bg-black hover:bg-zinc-800">Salva</Button></DialogFooter>
          </DialogContent>
        </Dialog>
        </div>
      </div>

      <div className="flex gap-2">
        <button data-testid="tab-atletico" onClick={() => setTab("atletico")} className={`px-4 py-2 rounded-md text-sm font-semibold ${tab === "atletico" ? "bg-black text-white" : "bg-white border border-zinc-200"}`}>Atletico</button>
        <button data-testid="tab-scherma" onClick={() => setTab("scherma")} className={`px-4 py-2 rounded-md text-sm font-semibold ${tab === "scherma" ? "bg-black text-white" : "bg-white border border-zinc-200"}`}>Scherma</button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filtered.map((ex) => (
          <div key={ex.id} className="bg-white border border-zinc-200 rounded-md p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="text-[10px] uppercase tracking-wider text-zinc-500 font-mono mb-1">{ex.category || "—"}</div>
                <div className="font-medium">{ex.title}</div>
              </div>
              <button onClick={() => archive(ex)} title="Archivia" className="text-zinc-400 hover:text-black p-1"><Archive className="w-4 h-4" /></button>
            </div>
            {ex.description && <p className="text-xs text-zinc-600 mt-2 line-clamp-2">{ex.description}</p>}
            <div className="flex gap-2 mt-3 text-[11px] font-mono text-zinc-500">
              {ex.duration && <span>{ex.duration}</span>}
              {ex.sets && <span>{ex.sets}×{ex.reps || "—"}</span>}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="col-span-full text-zinc-500">Nessun esercizio.</div>}
      </div>
    </div>
  );
}
